
import "./billingSheet.css";
import React, { useEffect, useState } from "react";
import { gettingUsers, gettingActivity } from "../../api";
import Header from "../../Components/Header/Header";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import chunk from "chunk";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import Pagination from "react-js-pagination";

function Activity() {

    const [isOpenUsersType, setIsOpenUsersType] = useState<boolean>(false);
    const [usersValue, setUsersValue] = useState<boolean>();
    const [isOpenLog, setIsOpenLog] = useState<boolean>(false);
    const [logValue, setLogValue] = useState<number>(20);
    const [filterBtn, setFilterBtn] = useState(false);
    const [activityDate, setActivityDate] = useState<string | undefined>();
    const [resetFilterBtn, setResetFilterBtn] = useState<boolean>(false);
    const [activityUsers, setActivityUsers] = useState<Array<any>>([]);
    const [activePage, setActivePage] = useState<number>(1);
    const [showLogs, setShowLogs] = useState<Array<any>>([]);
    const [showLogsChunk, setShowLogsChunk] = useState<Array<any>>([]);
    const [logs, setLogs] = useState<Array<any>>([])

    const togglingUsers = () => setIsOpenUsersType(!isOpenUsersType);

    const onUserOptionClicked = (value: any) => () => {
        setUsersValue(value);
        setIsOpenUsersType(false);
    };

    const togglingLogs = () => setIsOpenLog(!isOpenLog);

    const onLogClicked = (value: number) => () => {
        setLogValue(value);
        setIsOpenLog(false);
    };

    useEffect(() => {
        if (usersValue) {
            setFilterBtn(true)
            setResetFilterBtn(true)
        }
    }, [usersValue])

    const resetFilterFields = async () => {
        setUsersValue(false);
        setActivityDate("");
        setActivePage(1);
        await gettingActivityLogs();
    }

    const gettingActivityUsers = async () => {
        const getUsers:any = await gettingUsers();
        if (getUsers.data) {
            setActivityUsers(getUsers.data);
        }
    }

    useEffect(() => {
        gettingActivityUsers().then(r => r);
    }, []);

    const gettingActivityLogs = async () => {
        const getLogs:any = await gettingActivity();
        if (getLogs.data) {
            setLogs(getLogs.data);
        }
    }

    useEffect(() => {
        gettingActivityLogs().then(r => r);
    }, []);

    useEffect(() => {
        setShowLogs(logs);
    }, [logs])

    type TObj = {
        activityDate: string | undefined;
        usersValue: boolean | undefined
    }

    const logsFiltering = () => {
        setShowLogs(logs);

        let data: TObj   = {
            activityDate,
            usersValue
        }

        let dateReplace: string;

        if (data.activityDate !== undefined) {
            dateReplace = new Date(data.activityDate).toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            }).replaceAll("/", ".")
        }
        let key: keyof TObj;

        for ( key in data ) {
            if (data[key]) {
                if (key === "activityDate") {
                    setShowLogs(logs => logs.filter(log => log.message.includes(dateReplace)));
                }
                else {
                    setShowLogs(logs => logs.filter(log => log.message.includes(data[key])));
                }
            }
        }
        setActivePage(1)
    }

    const handleActivityPageChange = (pageNumber: number) => {
        setActivePage(pageNumber);
    }

    useEffect(() => {
        setActivePage(1);
        const chunkData = chunk(showLogs, logValue);
        setShowLogsChunk(chunkData[activePage - 1]);
        setShowLogsChunk(chunkData[activePage - 1]);
    }, [logValue]);

    useEffect(() => {
        const chunkData = chunk(showLogs, logValue);
        setShowLogsChunk(chunkData[activePage - 1]);
    }, [activePage, showLogs])

    return(
        <div className = "Activity">
            <Header />
            <div className = "activity-container">
                <div className = "activity-header">
                    <div className = "activity-header-heading">
                        <span className = "createClientLeftArrowBox">
                            <KeyboardArrowLeftIcon
                                style = {{
                                    color: "#004DE7"
                                }}
                                onClick = { () => window.history.back() }
                            />
                        </span>
                        <h2>Activity</h2>
                        <div className = "activity-filter mrg-btm">
                            <div className = "activity-filter-heading">
                                <span>Filter By</span>
                            </div>
                            <div className = "activity-filter-fields">
                                <div className = "activity-filter-fields-inputs">
                                    <div className = "form-type-box">
                                        <input
                                            type = "date"
                                            className = "activityDate"
                                            placeholder = "Date"
                                            value = { activityDate }
                                            onChange = { (e: React.ChangeEvent<HTMLInputElement>) => {
                                                setActivityDate(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className = "form-type-box">
                                        <div className = "activity-filter-selectBox-dropdown-container">
                                            <div className = "activity-filter-selectBox-dropdown-header"
                                                 onClick = { togglingUsers }>
                                                { usersValue ? usersValue : "Name of User" }
                                                <ArrowDropDownRoundedIcon
                                                    className = "activity-filter-selectBox-dropdown-header-arrow"
                                                />
                                            </div>
                                            { isOpenUsersType && (
                                                <ul className = "activity-filter-selectBox-dropdown-list">
                                                    {
                                                        activityUsers?.map((user) => (
                                                            <li
                                                                className = "activity-filter-selectBox-dropdown-li"
                                                                onClick = { onUserOptionClicked(user.fullName) }
                                                            >
                                                                { user.fullName }
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className = "activity-filter-fields-btn">
                                    <button
                                        style = {{
                                            color: filterBtn ? "white" : "#004DE7",
                                            backgroundColor: filterBtn ? "#004DE7" : "transparent",
                                            cursor: filterBtn ? 'pointer' : 'not-allowed',
                                        }}
                                        onClick = { logsFiltering }
                                    >
                                        Filter
                                    </button>
                                </div>

                                <div className = "activity-filter-selectBox-dropdown-container">
                                    <div className = "activity-filter-selectBox-dropdown-header"
                                         onClick = { togglingLogs }>
                                        { logValue ? logValue : "Number of Logs" }
                                        <ArrowDropDownRoundedIcon
                                            className = "activity-filter-selectBox-dropdown-header-arrow"/>
                                    </div>
                                    {
                                        isOpenLog && (
                                            <ul className = "activity-filter-selectBox-dropdown-list">
                                                <li className = "activity-filter-selectBox-dropdown-li"
                                                    onClick = { onLogClicked(20) }
                                                >
                                                    20
                                                </li>
                                                <li className = "activity-filter-selectBox-dropdown-li"
                                                    onClick = { onLogClicked(50) }
                                                >
                                                    50
                                                </li>
                                                <li className = "activity-filter-selectBox-dropdown-li"
                                                    onClick = { onLogClicked(100) }
                                                >
                                                    100
                                                </li>
                                            </ul>
                                        )
                                    }
                                </div>
                                <div
                                    className = "activity-filter-fields-reset-btn"
                                    title = "Clear"
                                    style = {{ display: resetFilterBtn ? "flex" : "none" }}
                                    onClick = { resetFilterFields }
                                >
                                    <RestartAltRoundedIcon/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className = "activity-logs">
                    {
                        showLogsChunk?.map((log) => {
                            const parts = log.message.split('--');
                            return (
                                <p key = { log.id }>
                                    { parts.length > 2 ? (
                                        <>
                                            <p className = "log-time-user-text">{ parts[0] }{' '}</p>
                                            <span
                                                // onClick={() => goToClientInfo(log.clientId)}
                                            >
                                                {' '}{parts[1]}{' '}
                                            </span>
                                            <p className = "log-message-text">
                                                { parts[2] }
                                            </p>
                                        </>
                                        ) : (
                                            <p className = "log-time-user-text">{ log.message }</p>
                                        )
                                    }
                                </p>
                            );
                        })
                    }
                </div>
                <div className = "allClients-pages">
                    <Pagination
                        activeLinkClass = "activeLogPageNumber"
                        linkClass = "logPageNumber"
                        activePage = { activePage }
                        itemsCountPerPage = { logValue }
                        totalItemsCount = { showLogs.length }
                        pageRangeDisplayed = { 5 }
                        hideFirstLastPages = { false }
                        onChange = { handleActivityPageChange }
                    />
                </div>
            </div>
        </div>
    )
}

export default Activity
